import { useMemo } from 'react';
import { EXCLUDED_DISK_TYPES } from 'usage/constants/usageConstants';
import { usePreferences } from 'users/hooks/react-query/usePreferences';

const useGetPreferencesMultiSelectValues = () => {
  const preferencesHook = usePreferences();
  const { data: instanceTypesData } = preferencesHook.fetchInstanceTypesList();

  const preferencesMultiSelectValues = useMemo(() => {
    const initialMultiSelectValues = {
      excludedDiskTypes: Object.values(EXCLUDED_DISK_TYPES),
      excludedInstanceTypes: [],
    };
    if (instanceTypesData) {
      initialMultiSelectValues.excludedInstanceTypes = instanceTypesData.instanceTypes;
    }
    return initialMultiSelectValues;
  }, [instanceTypesData]);

  return {
    preferencesMultiSelectValues,
  };
};

export default useGetPreferencesMultiSelectValues;
